import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HebDateUtil,  } from '../Util/HebDateUtil';
import { HDate } from '@hebcal/core';
import { DataBroker } from '../Util/DataBroker';

import IconShare from '../Icons/IconShare';
import IconBookmark from '../Icons/IconBookmark';
import { getBookmark } from '../Util/Bookmarks';



const Menu = (props) => {
  const navigate = useNavigate();

  const [stateMenu, setStateMenu] = useState(null);
  const [stateVersion, setStateVersion] = useState("");

  useEffect(() => {
    DataBroker.getDataJson('menu').then((menuJson) => {
      setStateVersion(menuJson.versions[menuJson.versions.length-1].version);
      setStateMenu(menuJson);
    });
  }, []);
  useEffect(() => {
    if (props.version && props.version !== "0.0")
      setStateVersion(props.version);
  }, [props.version]);

  const shareTfilulari = () => {
    console.log("Shared successfully");

    const shareData = {
      title: "Tfilulari",
      text: "Tfilulari",
      url: "https://tfilulari.com/",
    };

    try {
      navigator.share(shareData);
      console.log("Shared successfully");
    }
    catch (err) {
      console.log("Shared error", err);
    }
  };


  if (!stateMenu)
    return  <div className='menu'>
              <br/>
              <div className='menu-section'>
                <h4>טוען נתונים...</h4>
              </div>
            </div>;

  return (
    <div className='menu'>
        <br/>
        { 
          stateMenu.menu.map(mi =>
            <React.Fragment key={mi.key}>
                <b>{mi.title}</b>
                <div className='menu-section'>
                  {
                    mi.items.map(li => {
                      if (!li.condition || HebDateUtil.GetCondition(li.condition, new HDate()))
                        return  <div key={li.type} onClick={ () => { navigate(`${li.type}`); window.scrollTo(0,0); } }>{li.name}
                                  {
                                    li.prakim &&
                                    <a onClick={ (event) => { event.stopPropagation(); navigate(`/pr/${li.type}`); window.scrollTo(0,0); } }>פרקים</a>
                                  }
                                  {
                                    getBookmark(li.type) &&
                                    <a className='menu-bookmark' onClick={ (event) => { event.stopPropagation(); navigate(`${li.type}`, { state: { gotoBookmark: true } }); window.scrollTo(0,0); } }><IconBookmark /></a>
                                  }
                                </div>
                    })
                  }
                </div>
            </React.Fragment>
          )
        }
        <center key="version" className='menu-version'>גירסה: { stateVersion }</center>
        <br/>
        <a className="menu-float-icon-share" onClick={ shareTfilulari }><IconShare /></a>
    </div>
  );
}

export default Menu;
